import { CircularProgress, createTheme, ThemeProvider } from '@mui/material';
import { useEffect, useState } from 'react';
import { setDefaultURL } from "./api/api";
import envInstants from "./libs/configs/env";
import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './view/login';
import RequireAuth from './component/RequireAuth';
import Layout from './component/Layout';
import { useDispatch } from 'react-redux';
import { profileAsync } from './store/slices/profileSlice';
import Dashboard from './view/dashboard';
import Stock from './view/stock';
import AddStockTransfer from './view/stock/addStockTransfer'
import AddReserveHq from './view/stock/addReserveHq'
import AddStockAdjust from './view/stock/addStockAdjust'
import Sale from './view/sale'
import ViewPromotion from './view/sale/viewPromotion'
import Plan from './view/plan'
import ViewProductionPlan from './view/plan/viewProductionPlan'
import ViewDistributionPlan from './view/plan/viewDistributionPlan'
import ViewPromoteSpread from './view/plan/viewPromoteSpread'
import ViewCampaignPlan from './view/plan/viewCampaignPlan'
import Report from './view/report'
import Agent from './view/agent'
import ViewCustomer from './view/agent/viewCustomer'
import ViewAgent from './view/agent/viewAgent'
import Setting from './view/setting';
import ViewItem from './view/setting/viewItem';
import ViewBranchs from './view/setting/viewBranchs';
import ViewEmployee from './view/setting/viewEmployee';
import ViewDiscountSale from './view/setting/viewDiscountSale';
import AddReserve from './view/stock/addReserve';
import CoppyListView from './view/sale/coppyListView';
import ReportDialySale from './view/report/reportDialySale';
import ReportSaleAgent from './view/report/reportSaleAgent';
import ReportSale from './view/report/reportSale';
import ReportSaleLocation from './view/report/reportSaleLocation';
import ReportIncome from './view/report/reportIncome';
import ReportCustomer from './view/report/reportCustomer';
import ReportAgent from './view/report/reportAgent';
import ReportSalePromotion from './view/report/reportSalePromotion';
import ReportStock from './view/report/reportStock';
import ReportTransfer from './view/report/reportTransfer';
import ReportReceive from './view/report/reportReceive';
import ReportPlanProduction from './view/report/reportPlanProduction';
import ReportPlanReview from './view/report/reportPlanReview';
import ReportPlanSale from './view/report/reportPlanSale';
import ReportPlanDistribution from './view/report/reportPlanDistribution';
import ReportInspection from './view/report/reportInspection';
import ReportDelvieryCost from './view/report/reportDelvieryCost';
import ReportFuelCost from './view/report/reportFuelCost';
import ReportDelvieryTen from './view/report/reportDelvieryTen';
import RoleView from './view/setting/roleView';
import { notiAsync } from './store/slices/notiSlice';
import StockBalance from './view/stock/stockBalance';
import { StockProvider } from './view/stock/services/stockApi';
// import ItemSale from './view/sale/itemSale';
import CoppyList from './view/sale/coppyList';
import { SaleProvider } from './view/sale/services/saleApi';
import Promotion from './view/sale/promotion';
import ProductionPlan from './view/plan/productionPlan';
import DistributionPlan from './view/plan/distributionPlan';
import PromoteSpread from './view/plan/promoteSpread';
import Delivery from './view/plan/delivery';
import CampaignPlan from './view/plan/campaignPlan';
import { PlanProvider } from './view/plan/services/planApi';
import CustomerList from './view/agent/customerList';
import AgentList from './view/agent/agentList';
import Item from './view/setting/item';
import Branchs from './view/setting/branchs';
import Role from './view/setting/role';
import Employee from './view/setting/employee';
import DiscountSale from './view/setting/discountSale';
import BudgetYears from './view/setting/budgetYears';
import ChangePassword from './view/setting/changePassword';
import Wherehouse from './view/setting/wherehouse';
import Groups from './view/setting/groups';
import ResetPassword from './view/resetPassword';
import Material from './view/setting/material';
import ViewMaterial from './view/setting/viewMaterial';
import Materials from './view/materials';
import Receipt from './view/receipt';
import ReceiptList from './view/receipt/receiptList';
import ReceiptDetail from './view/receipt/receiptDetail';
import MaterialsReceiveList from './view/materials/receive/list';
import MaterialsReceiveAdd from './view/materials/receive/add';
import MaterialsReceiveDetail from './view/materials/receive/detail.js';
import MaterialsReturnsList from './view/materials/returns/list';
import MaterialsReturnsAdd from './view/materials/returns/add';
import MaterialsReturnsDetail from './view/materials/returns/detail.js';
import MaterialsExpensesList from './view/materials/expenses/list';
import MaterialsExpensesAdd from './view/materials/expenses/add';
import MaterialsExpensesDetail from './view/materials/expenses/detail.js';
import MaterialsLendsAdd from './view/materials/lends/add';
import MaterialsLendsList from './view/materials/lends/list';
import MaterialsLendsDetail from './view/materials/lends/detail.js';
import MaterialsTransfersList from './view/materials/transfers/list';
import MaterialsTransfersAdd from './view/materials/transfers/add';
import MaterialsTransfersDetail from './view/materials/transfers/detail.js';
import MaterialsBalanceList from './view/materials/balance/list';
import MaterialsRepairList from './view/materials/repair/list';
import MaterialsRepairAdd from './view/materials/repair/add';
import MaterialsRepairDetail from './view/materials/repair/detail';
import MaterialsDebitList from './view/materials/debit/list/indext';
import MaterialsDebitAdd from './view/materials/debit/add';
import MaterialsDebitDetail from './view/materials/debit/detail';
import StockRawList from './view/stock/stockRaw/list';
import StockRawAdd from './view/stock/stockRaw/add';
import StockCulledList from './view/stock/stockCulled/list';
import StockRawDetail from './view/stock/stockRaw/detail';
import StockCulledAdd from './view/stock/stockCulled/add';
import StockCulledDetail from './view/stock/stockCulled/detail';
import Test from './view/materials/test';
import RepurchaseList from './view/raw/repurchase/list';
import PaidForFactoryList from './view/raw/paidForFactory/list';
import ReceivedAfterImprovementList from './view/raw/receivedAfterImprovement/list';
import PaidForMarketingList from './view/raw/paidForMarketing/list';
import PaidForFactoryAdd from './view/raw/paidForFactory/add';
import RawBalance from './view/raw/rawBalance/list';
import RepurchaseAdd from './view/raw/repurchase/add';
import PaidForMarketingAdd from './view/raw/paidForMarketing/add';
import ReceivedAfterImprovementAdd from './view/raw/receivedAfterImprovement/add';
import StockReceiveList from './view/stock/stockReceive/list';
import StockTransferList from './view/stock/stockTransfer/list';
import ReserveList from './view/stock/reserve/list';
import ReserveHqList from './view/stock/reserveHq/list';
import StockAdjustList from './view/stock/stockAdjust/list';
import StockReceiveAdd from './view/stock/stockReceive/add';
import StockReceiveDetail from './view/stock/stockReceive/detail';
import RepurchaseDatail from './view/raw/repurchase/detail';
import PaidForFactoryDatail from './view/raw/paidForFactory/detail';
import PaidForMarketingDatail from './view/raw/paidForMarketing/detail';
import ReceivedAfterImprovementDatail from './view/raw/receivedAfterImprovement/detail';
import ItemSale from './view/sale/itemSale/add';
import News from './view/setting/news';
import ViewNews from './view/setting/viewNews';
import ReportRaw from './view/report/reportRaw.js';
import ReportCost from './view/report/reportCost.js';
import ReportReceipt from './view/report/reportReceipt.js';
import ReportDiscard from './view/report/reportDiscard.js';
import ReporttBalaneMaterials from './view/report/reportBalaneMaterials.js';
import ReportSeedProduceCostByItem from './view/report/reportSeedProduceCostByItem.js';
import LotMovementReport from './view/report/lotMovementReport.js';
import AddCost from './view/stock/cost/add.js';
import DaysInStockReport from './view/report/daysInStockReport.js';
import ReportRiceSeedReserve from './view/report/reportRiceSeedReserve.js';
import ReportMaterialProduction from './view/report/reportMaterialProduction.js';
import MaterialDashboard from './view/materials/dashboard/index.js';
function App() {
  const theme = createTheme({
    typography: {
      fontFamily: "'Prompt', sans-serif"
    },
    palette: {
      primary: {
        main: '#1565c0'
      }
    },
  });
  const [isInitEnvError, setInitEnvError] = useState(false);
  const [isInitEnv, setInitEnv] = useState(false);
  const dispatch = useDispatch();


  const local_token = localStorage.getItem("accessTR");


 

  useEffect(() => {
    const loadEnv = async () => {

      try {
        await envInstants.init();
        setDefaultURL(envInstants.getConfig().baseUrl);
        const url = envInstants.getConfig().baseUrl;
        localStorage.setItem("url", url);
        if (local_token) {
          dispatch(profileAsync());
          // dispatch(actionAsync());
          // dispatch(baseUrlAsync(url));

          const interval = setInterval(() => {
            dispatch(notiAsync());
          }, 1000 * 60);
          dispatch(notiAsync());

          return () => clearInterval(interval)
        }
        // dispatch(getActions());


      } catch (error) {
        setInitEnvError(true);
      } finally {
        setInitEnv(true);
      }
    };

    loadEnv();

  }, [dispatch, local_token]);
 
  if (!isInitEnv) return <CircularProgress />;
  if (isInitEnvError) return "Cannot load env !!!";



  return (
    <ThemeProvider theme={theme}>
      <Routes>
        {local_token ? (
          <Route path="*" element={<Navigate to="/" />} />
        ) : (
          <Route path="/Login" element={<Login />} />
        )}
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<Layout />}>
            <Route exact path='/' element={<Dashboard />} />


            <Route path='/stock' element={<Stock />} />
            <Route path='/stock/balance' element={<StockBalance />} />
            <Route path='/stock/stock-receive' element={<StockReceiveList />} />
            <Route path='/stock/stock-raw' element={<StockRawList />} />
            <Route path='/stock/stock-raw/add' element={<StockRawAdd />} />
            <Route path='/stock/stock-raw/:id' element={<StockRawDetail />} />
            <Route path='/stock/stock-receive/add' element={<StockReceiveAdd />} />
            <Route path='/stock/stock-receive/:id' element={<StockReceiveDetail />} />
            <Route path='/stock/stock-culled' element={<StockCulledList />} />
            <Route path='/stock/stock-culled/add' element={<StockCulledAdd />} />
            <Route path='/stock/stock-culled/:id' element={<StockCulledDetail />} />

            <Route path='/stock/stock-transfer' element={<StockTransferList />} />
            <Route path='/stock/stock-transfer/add' element={<AddStockTransfer />} />
            <Route path='/stock/stock-transfer/:id' element={<AddStockTransfer />} />
            <Route path='/stock/reserve' element={<ReserveList />} />
            <Route path='/stock/reserve/add' element={<StockProvider><AddReserve /></StockProvider>} />
            <Route path='/stock/reserve/:id' element={<StockProvider><AddReserve /></StockProvider>} />
            <Route path='/stock/reserve-hq' element={<ReserveHqList />} />
            <Route path='/stock/reserve-hq/add' element={<StockProvider><AddReserveHq /></StockProvider>} />
            <Route path='/stock/reserve-hq/:id' element={<StockProvider><AddReserveHq /></StockProvider>} />
            <Route path='/stock/stock-adjust' element={<StockAdjustList />} />
            <Route path='/stock/stock-adjust/add' element={<StockProvider><AddStockAdjust /></StockProvider>} />
            <Route path='/stock/stock-adjust/:id' element={<StockProvider><AddStockAdjust /></StockProvider>} />

            <Route path='/stock/cost' element={<AddCost />} />


            <Route path='/raw' element={<RawBalance />} />
            <Route path='/raw/balance' element={<RawBalance />} />
            <Route path='/raw/repurchase' element={<RepurchaseList />} />
            <Route path='/raw/repurchase/add' element={<RepurchaseAdd />} />
            <Route path='/raw/repurchase/:id' element={<RepurchaseDatail />} />
            <Route path='/raw/paidforfactory' element={<PaidForFactoryList />} />
            <Route path='/raw/paidforfactory/add' element={<PaidForFactoryAdd />} />
            <Route path='/raw/paidforfactory/:id' element={<PaidForFactoryDatail />} />
            <Route path='/raw/receivedafterimprovement' element={<ReceivedAfterImprovementList />} />
            <Route path='/raw/receivedafterimprovement/add' element={<ReceivedAfterImprovementAdd />} />
            <Route path='/raw/receivedafterimprovement/:id' element={<ReceivedAfterImprovementDatail/>} />
            <Route path='/raw/paidformarketing' element={<PaidForMarketingList />} />
            <Route path='/raw/paidformarketing/add' element={<PaidForMarketingAdd />} />
            <Route path='/raw/paidformarketing/:id' element={<PaidForMarketingDatail />} />

            <Route path='/sale' element={<Sale />} />
            <Route path='/sale/item-sale' element={<SaleProvider><ItemSale /></SaleProvider>} />
            <Route path='/sale/coppy-list' element={<SaleProvider><CoppyList /></SaleProvider>} />
            <Route path='/sale/coppy-list/:id' element={<SaleProvider><CoppyListView /></SaleProvider>} />
            <Route path='/sale/promotion' element={<SaleProvider><Promotion /></SaleProvider>} />
            <Route path='/sale/promotion/add' element={<SaleProvider><ViewPromotion /></SaleProvider>} />
            <Route path='/sale/promotion/:id' element={<SaleProvider><ViewPromotion /></SaleProvider>} />

            <Route path='/materials' element={<Materials />} />
            <Route path='/materials/materials-dashboard' element={<MaterialDashboard />} />
            <Route path='/materials/materials-returns' element={<MaterialsReturnsList />} />
            <Route path='/materials/materials-returns/add' element={<MaterialsReturnsAdd />} />
            <Route path='/materials/materials-returns/:id' element={<MaterialsReturnsDetail />} />
            <Route path='/materials/materials-lends' element={<MaterialsLendsList />} />
            <Route path='/materials/materials-lends/add' element={<MaterialsLendsAdd />} />
            <Route path='/materials/materials-lends/:id' element={<MaterialsLendsDetail />} />
            <Route path='/materials/materials-expenses' element={<MaterialsExpensesList />} />
            <Route path='/materials/materials-expenses/add' element={<MaterialsExpensesAdd />} />
            <Route path='/materials/materials-expenses/:id' element={<MaterialsExpensesDetail />} />
            <Route path='/materials/materials-receive' element={<MaterialsReceiveList />} />
            <Route path='/materials/materials-receive/add' element={<MaterialsReceiveAdd />} />
            <Route path='/materials/materials-receive/:id' element={<MaterialsReceiveDetail />} />
            <Route path='/materials/materials-transfers' element={<MaterialsTransfersList />} />
            <Route path='/materials/materials-transfers/add' element={<MaterialsTransfersAdd />} />
            <Route path='/materials/materials-transfers/:id' element={<MaterialsTransfersDetail />} />
            <Route path='/materials/materials-repair' element={<MaterialsRepairList />} />
            <Route path='/materials/materials-repair/add' element={<MaterialsRepairAdd />} />
            <Route path='/materials/materials-repair/:id' element={<MaterialsRepairDetail />} />
            <Route path='/materials/materials-debit' element={<MaterialsDebitList />} />
            <Route path='/materials/materials-debit/add' element={<MaterialsDebitAdd />} />
            <Route path='/materials/materials-debit/:id' element={<MaterialsDebitDetail />} />
            <Route path='/materials/materials-balance' element={<MaterialsBalanceList/>} />
            <Route path='/materials/test' element={<Test/>} />

            <Route path='/receipt' element={<Receipt />} />
            <Route path='/receipt/receipt-list' element={<ReceiptList />} />
            <Route path='/receipt/receipt-list/:id' element={<ReceiptDetail />} />


            <Route path='/plan' element={<Plan />} />
            <Route path='/plan/production-plan' element={<PlanProvider><ProductionPlan /></PlanProvider>} />
            <Route path='/plan/production-plan/add' element={<PlanProvider><ViewProductionPlan /></PlanProvider>} />
            <Route path='/plan/production-plan/:id' element={<PlanProvider><ViewProductionPlan /></PlanProvider>} />
            <Route path='/plan/distribution-plan' element={<PlanProvider><DistributionPlan /></PlanProvider>} />
            <Route path='/plan/distribution-plan/add' element={<PlanProvider><ViewDistributionPlan /></PlanProvider>} />
            <Route path='/plan/distribution-plan/:id' element={<PlanProvider><ViewDistributionPlan /></PlanProvider>} />
            <Route path='/plan/promote-spread' element={<PlanProvider><PromoteSpread /></PlanProvider>} />
            <Route path='/plan/promote-spread/add' element={<PlanProvider><ViewPromoteSpread /></PlanProvider>} />
            <Route path='/plan/promote-spread/:id' element={<PlanProvider><ViewPromoteSpread /></PlanProvider>} />
            <Route path='/sale/delivery' element={<PlanProvider><Delivery /></PlanProvider>} />
            <Route path='/sale/campaign-plan' element={<PlanProvider><CampaignPlan /></PlanProvider>} />
            <Route path='/sale/campaign-plan/:id' element={<PlanProvider><ViewCampaignPlan /></PlanProvider>} />

            <Route path='/report' element={<Report />} />
            <Route path='/report/report-dialy-sale' element={<ReportDialySale />} />
            <Route path='/report/report-sale-agent' element={<ReportSaleAgent />} />
            <Route path='/report/report-sale' element={<ReportSale />} />
            <Route path='/report/report-sale-location' element={<ReportSaleLocation />} />
            <Route path='/report/report-income' element={<ReportIncome />} />
            <Route path='/report/report-customer' element={<ReportCustomer />} />
            <Route path='/report/report-agent' element={<ReportAgent />} />
            <Route path='/report/report-sale-promotion' element={<ReportSalePromotion />} />
            <Route path='/report/report-stock' element={<ReportStock />} />
            <Route path='/report/report-transfer' element={<ReportTransfer />} />
            <Route path='/report/report-receive' element={<ReportReceive />} />
            <Route path='/report/report-plan-production' element={<ReportPlanProduction />} />
            <Route path='/report/report-plan-review' element={<ReportPlanReview />} />
            <Route path='/report/report-plan-sale' element={<ReportPlanSale />} />
            <Route path='/report/report-plan-distribution' element={<ReportPlanDistribution />} />
            <Route path='/report/report-inspection' element={<ReportInspection />} />
            <Route path='/report/report-delviery-cost' element={<ReportDelvieryCost />} />
            <Route path='/report/report-fuel-cost' element={<ReportFuelCost />} />
            <Route path='/report/report-delviery-ten' element={<ReportDelvieryTen />} />
            <Route path='/report/report-raw' element={<ReportRaw />} />
            <Route path='/report/report-cost' element={<ReportCost />} />
            <Route path='/report/report-receipt' element={<ReportReceipt />} />
            <Route path='/report/report-discard' element={<ReportDiscard />} />
            <Route path='/report/report-balane-materials' element={<ReporttBalaneMaterials />} />
            <Route path='/report/report-seed-produce-cost-by-item' element={<ReportSeedProduceCostByItem />} />
            <Route path='/report/lot-movement-report' element={<LotMovementReport />} />
            <Route path='/report/day-in-stock-report' element={<DaysInStockReport />} />
            <Route path='/report/report-rice-seed-reserve' element={<ReportRiceSeedReserve />} />
            <Route path='/report/report-material-production' element={<ReportMaterialProduction />} />

            <Route path='/agent' element={<Agent />} />
            <Route path='/agent/customer-list' element={<CustomerList />} />
            <Route path='/agent/customer-list/add' element={<ViewCustomer />} />
            <Route path='/agent/customer-list/:id' element={<ViewCustomer />} />
            <Route path='/agent/agent-list' element={<AgentList />} />
            <Route path='/agent/agent-list/add' element={<ViewAgent />} />
            <Route path='/agent/agent-list/:id' element={<ViewAgent />} />
            
            <Route path='/setting' element={<Setting />} />
            <Route path='/setting/category' element={<Groups />} />
            <Route path='/setting/wherehouse' element={<Wherehouse />} />
            <Route path='/setting/materials/add' element={<ViewMaterial />} />
            <Route path='/setting/materials/:id' element={<ViewMaterial />} />
            <Route path='/setting/materials' element={<Material />} />
            <Route path='/setting/item' element={<Item />} />
            <Route path='/setting/item/add' element={<ViewItem />} />
            <Route path='/setting/item/:id' element={<ViewItem />} />
            <Route path='/setting/branchs' element={<Branchs />} />
            <Route path='/setting/branchs/add' element={<ViewBranchs />} />
            <Route path='/setting/branchs/:id' element={<ViewBranchs />} />
            <Route path='/setting/news' element={<News />} />
            <Route path='/setting/news/add' element={<ViewNews />} />
            <Route path='/setting/role' element={<Role />} />
            <Route path='/setting/role/:id' element={<RoleView />} />
            <Route path='/setting/employee' element={<Employee />} />
            <Route path='/setting/employee/add' element={<ViewEmployee />} />
            <Route path='/setting/employee/:id' element={<ViewEmployee />} />
            <Route path='/setting/discount-sale' element={<DiscountSale />} />
            <Route path='/setting/discount-sale/add' element={<ViewDiscountSale />} />
            <Route path='/setting/budget-years' element={<BudgetYears />} />
            <Route path='/setting/change-password' element={<ChangePassword />} />

          </Route>
        </Route>

      </Routes>
    </ThemeProvider >
  );
}

export default App;
